import Vue from "vue";
import Vuex from "vuex";
import page from "./modules/page.js";
import state from './state';
import mutations from './mutations';
Vue.use(Vuex);

export default new Vuex.Store({
  state,
  mutations,
  actions: {
    setActiveRoute({ commit }, value) {
      commit('SET_ACTIVE_ROUTE', value)
    }
  },
  modules: { page },
});
